import { orderIndexBulkResourceFilterUpdate } from '@dispatch/shared/services';
import { ResourcesListFilter } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useFiltersOrderIndexBulkResourceFilterUpdate = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-resource-bulk-filter', userId],
    (data: (Omit<ResourcesListFilter, 'pageSize'> & { isNew?: boolean })[]) =>
      orderIndexBulkResourceFilterUpdate(data, userId),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    orderIndexBulkUpdate: mutate,
    orderIndexBulkUpdateError: error,
    orderIndexBulkUpdateStatus: status,
  };
};
